import { useTranslation } from 'react-i18next'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import Loading from '@/widgets/Loading'
import MonthView from './components/MonthView'
import useTrainingsCalendarPage from './hooks/useTrainingsCalendarPage'

export default function TrainingsCalendarPage() {
	const { t } = useTranslation()
	const {
		dateDisplay,
		datePickerRef,
		error,
		handleAdd,
		handleDatePickerBlur,
		handleDatePickerChange,
		handleNext,
		handlePrevious,
		handleToday,
		handleToggleDatePicker,
		inputRef,
		loading,
		showDatePicker,
		startDate,
		tempDate,
		trainings,
	} = useTrainingsCalendarPage()

	if (loading) {
		return <Loading />
	}

	return (
		<div className="space-y-4">
			{error && (
				<div className="rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">{error}</div>
			)}

			<div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex w-full items-center gap-2 sm:w-auto sm:gap-4">
					<button onClick={handlePrevious} className="shrink-0 cursor-pointer rounded-md p-2 hover:bg-gray-100">
						<ChevronLeftIcon className="h-5 w-5 text-gray-600" />
					</button>
					<div className="relative min-w-0 flex-1 sm:flex-none" ref={datePickerRef}>
						<h2
							onClick={handleToggleDatePicker}
							className="cursor-pointer truncate text-center text-base font-medium text-gray-900 hover:text-gray-700 sm:min-w-[250px] sm:text-lg">
							{dateDisplay}
						</h2>
						{showDatePicker && (
							<input
								ref={inputRef}
								type="date"
								value={tempDate}
								onChange={handleDatePickerChange}
								onBlur={handleDatePickerBlur}
								className="absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 rounded-md border border-gray-300 bg-white px-3 py-2 shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
								autoFocus
							/>
						)}
					</div>
					<button onClick={handleNext} className="shrink-0 cursor-pointer rounded-md p-2 hover:bg-gray-100">
						<ChevronRightIcon className="h-5 w-5 text-gray-600" />
					</button>
					<button
						onClick={handleToday}
						className="hidden cursor-pointer rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 sm:inline-flex">
						{t('trainings.calendar.actions.today')}
					</button>
				</div>

				<div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3">
					<button
						onClick={handleToday}
						className="inline-flex cursor-pointer items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 sm:hidden">
						{t('trainings.calendar.actions.today')}
					</button>
					<button
						type="button"
						onClick={handleAdd}
						className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
						{t('trainings.calendar.actions.addNew')}
					</button>
				</div>
			</div>

			<MonthView trainings={trainings} startDate={startDate} />
		</div>
	)
}
